import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { LanguageSelector } from '../components/LanguageSelector';
import { ArrowLeft, FileText } from 'lucide-react';
import ReactMarkdown from 'react-markdown';

const TermsPage = () => {
  const { t, tObj, getTranslation } = useLanguage();
  const sections = tObj('terms.sections') || [];

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img 
                src="/logo-horizontal-trimmed.png" 
                alt="ServiCare" 
                className="h-9 sm:h-10 object-contain"
              />
            </Link>
            <div className="flex items-center gap-3">
              <LanguageSelector variant="minimal" />
              <Link to="/">
                <Button variant="outline" size="sm">
                  <ArrowLeft className="w-4 h-4 mr-1" />
                  {t('common.buttons.back')}
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        {/* Title */}
        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-sm mb-8">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-2 bg-amber-100 rounded-lg">
              <FileText className="w-6 h-6 text-amber-700" />
            </div>
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">
                {t('terms.title')}
              </h1>
              <p className="text-slate-500 text-sm mt-1">
                {t('terms.lastUpdate')}: Marzo 2025
              </p>
            </div>
          </div>
        </div>

        {/* Sections */}
        <div className="space-y-6">
          {sections.map((section, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-sm">
              <h2 className="text-lg font-semibold text-slate-900 mb-4">
                {getTranslation(section.title)}
              </h2>
              <div className="prose prose-slate prose-sm max-w-none">
                <ReactMarkdown>
                  {getTranslation(section.content)}
                </ReactMarkdown>
              </div>
            </div>
          ))}
        </div>

        {/* Back to Home */}
        <div className="mt-8 text-center">
          <Link to="/">
            <Button variant="outline">
              <ArrowLeft className="w-4 h-4 mr-2" />
              {t('common.nav.home')}
            </Button>
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-slate-200 py-6 mt-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center text-slate-500 text-sm">
          © {new Date().getFullYear()} ServiCare. {t('common.footer.rights')}.
        </div>
      </footer>
    </div>
  );
};

export default TermsPage;
